export const disableReactQuillClasses = (isDisabled: boolean) => {
	return isDisabled ? "pointer-events-none cursor-not-allowed" : "";
};
